import { render, staticRenderFns } from "./profileDropdownOption.vue?vue&type=template&id=3233ae57&scoped=true"
import script from "./profileDropdownOption.vue?vue&type=script&lang=js"
export * from "./profileDropdownOption.vue?vue&type=script&lang=js"
import style0 from "./profileDropdownOption.vue?vue&type=style&index=0&id=3233ae57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3233ae57",
  null
  
)

export default component.exports